var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "ma-0", attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { staticClass: "pa-0" },
            [
              _c(
                "v-row",
                { staticClass: "ma-0 mt-3" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pa-0" },
                    [
                      _c(
                        "v-card",
                        [
                          !_vm.railTimetables || _vm.railTimetables.length === 0
                            ? [
                                _c(
                                  "v-card-text",
                                  {
                                    staticClass:
                                      "d-flex align-center justify-center py-6",
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-2",
                                        attrs: { color: "warning", size: "20" },
                                      },
                                      [_vm._v("mdi-alert")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "font-weight-medium warning--text",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("label.noTrackingInfo"))
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : _vm.railTimetables.length === 1
                            ? [
                                _c("RailTimetableDetail", {
                                  attrs: { timetable: _vm.railTimetables[0] },
                                }),
                              ]
                            : [
                                _c(
                                  "v-tabs",
                                  {
                                    attrs: {
                                      "background-color": "accent",
                                      height: "2rem",
                                      grow: "",
                                    },
                                    model: {
                                      value: _vm.railTab,
                                      callback: function ($$v) {
                                        _vm.railTab = $$v
                                      },
                                      expression: "railTab",
                                    },
                                  },
                                  _vm._l(
                                    _vm.railTimetables,
                                    function (timetable) {
                                      return _c(
                                        "v-tab",
                                        { key: timetable.messageId },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-1",
                                              attrs: { small: "" },
                                            },
                                            [_vm._v("mdi-train")]
                                          ),
                                          _vm._v(
                                            " " +
                                              _vm._s(timetable.messageId) +
                                              " "
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                                _c(
                                  "v-tabs-items",
                                  {
                                    model: {
                                      value: _vm.railTab,
                                      callback: function ($$v) {
                                        _vm.railTab = $$v
                                      },
                                      expression: "railTab",
                                    },
                                  },
                                  _vm._l(
                                    _vm.railTimetables,
                                    function (timetable) {
                                      return _c(
                                        "v-tab-item",
                                        { key: timetable.messageId },
                                        [
                                          _c("RailTimetableDetail", {
                                            attrs: { timetable: timetable },
                                          }),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }